<template>
  <div style="width:100vw; position: relative; left: -8px;
    background-color: #222222;">
        <div style="height: 50px;">
            &nbsp;
        </div>
        <div :style="{width: getScreenWidth > 500 ? '70%' : '100%', margin: '0 auto'}">
            <div class="flexSpaceBetween" style="text-align: center; color: white;">
                <span class="heading"><h1>{</h1></span><span class="heading" style="top: 50px; position: relative;">Our web app and mobile app solutions implemented at</span><span class="heading"><h1>}</h1></span>
            </div>        
        </div>
        <div style="margin-top: 50px;">
            &nbsp;
        </div>
        
        <div style="width: 70%; margin: 0 auto;">
            <div style="display: flex; flex-direction: row; flex-wrap: wrap; justify-content: center; ">
                <a style="margin: 20px;" href="https://easytailorapp.com" target="_blank"><img src="https://cdn.easytailorapp.com/website/eta-logo-white.png" style="max-width: 150px;" alt=""></a>
                <a style="margin: 20px;" href="https://donquijoterecepciones.com" target="_blank"><img src="https://raizzoncdn.b-cdn.net/home/new/don_quijote.png" style="max-width: 250px;" alt=""></a>
                <a style="margin: 20px;" href="https://twistedsugar.com" target="_blank"><img src="https://raizzoncdn.b-cdn.net/home/new/twisted_sugar.png" style="max-width: 150px;" alt=""></a>
                <a style="margin: 20px;" href="https://www.allure-tailoring.com/" target="_blank"><img src="https://raizzoncdn.b-cdn.net/home/new/allure.png" style="max-width: 150px;" alt=""></a>
                <a style="margin: 20px;" href="https://laxmitailors.com/" target="_blank"><img src="https://raizzoncdn.b-cdn.net/home/new/laxmi_tailors.png" style="max-width: 150px;" alt=""></a>
                <a style="margin: 20px;" href="https://activz.com/" target="_blank"><img src="https://raizzoncdn.b-cdn.net/home/new/activz.png" style="max-width: 150px;" alt=""></a>
                <a style="margin: 20px;" href="https://h2forlife.com/" target="_blank"><img src="https://raizzoncdn.b-cdn.net/home/new/h2.png" style="max-width: 50px;" alt=""></a>
                <a style="margin: 20px;" href="https://miteshlodha.com/" target="_blank"><img src="https://raizzoncdn.b-cdn.net/home/new/ml.png" style="max-width: 50px;" alt=""></a>
                
            </div>            
        </div>
        <div style="height: 100px;">
            &nbsp;
        </div>
  </div>
</template>

<script>
export default {
    computed: {
        getScreenWidth() {
            return window.screen.width
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Home/Section4.vue